import { render, staticRenderFns } from "./EmailCard.vue?vue&type=template&id=955c4794&"
import script from "./EmailCard.vue?vue&type=script&lang=js&"
export * from "./EmailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports